// ---------------------------------------------------------------------------------------------------------------------
// Player video
// ---------------------------------------------------------------------------------------------------------------------
const playerVideoWraps = document.querySelectorAll('.js_player_video')
const iframeVideoWraps = document.querySelectorAll('.js_iframe_video')

function isVideoPlaying(video) {
  return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
}


function playVideo(videoWrap, video, playButton) {
  stopAllPlayerVideos();
  stopAllYouTubeVideos();
  videoWrap.classList.add('playing');
  if (!isVideoPlaying(video)) {
    video.play();
  }
}


//init only if page has play videos
function playerVideo() {
  if (playerVideoWraps !== undefined) {
    playerVideoWraps.forEach(function (element, index) {

      const videoWrap = element
      const video = element.querySelector('video')
      const playButton = element.querySelector('.js_player_video_overlay')

      // Track if autoplay has been handled
      let autoplayStarted = false

      // Pause video initially if it has autoplay attribute
      if (video.hasAttribute('autoplay')) {
        video.pause()
      }

      // Intersection Observer for autoplay on scroll into view
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !autoplayStarted && video.hasAttribute('autoplay')) {
            video.muted = true
            video.setAttribute('playsinline', '')
            video.play().catch(error => {
              console.log('Autoplay prevented:', error)
            })
            autoplayStarted = true
          }
        })
      }, {
        threshold: 0.5 // Trigger when 50% of video is visible
      })

      observer.observe(videoWrap)

      playButton.addEventListener('click', function (e) {
        playVideo(videoWrap, video, playButton);
      });

      video.addEventListener('pause', function (e) {
        videoWrap.classList.remove('playing');
      });

      video.addEventListener('play', function (e) {
        videoWrap.classList.add('playing');
      });

    });
  }
}

playerVideo();

// ---------------------------------------------------------------------------------------------------------------------
// Play only one video on the page
// ---------------------------------------------------------------------------------------------------------------------

function stopAllPlayerVideos() {
  if (playerVideoWraps !== undefined) {
    playerVideoWraps.forEach(function (element, index) {
      const videoWrap = element
      const video = element.querySelector('video')

      video.pause();
      videoWrap.classList.remove('playing');
    });
  }
}

// ---------------------------------------------------------------------------------------------------------------------
// YouTube videos
// ---------------------------------------------------------------------------------------------------------------------

function stopAllYouTubeVideos() {
  for (let i = 0; i < iframeVideoWraps.length; i++) {
    if (iframeVideoWraps[i]) {
      const iframe = iframeVideoWraps[i].getElementsByTagName('iframe')[0]
      const src = iframe.getAttribute('src')
      if (src) {
        if (src.indexOf('youtube-nocookie.com/embed') !== -1) {
          iframe.contentWindow.postMessage(JSON.stringify({
            'event': 'command',
            'func': 'pauseVideo',
            'args': []
          }), "*");
        }
      }
    }
  }
}


function pauseAllYoutubeVideosExcept(videoToPlay) {
  for (let i = 0; i < iframeVideoWraps.length; i++) {
    if (iframeVideoWraps[i]) {
      const iframe = iframeVideoWraps[i].getElementsByTagName('iframe')[0]
      const src = iframe.getAttribute('src')
      if (videoToPlay !== iframe) {
        if (src) {
          if (src.indexOf('youtube-nocookie.com/embed') !== -1) {
            iframe.contentWindow.postMessage(JSON.stringify({
              'event': 'command',
              'func': 'pauseVideo',
              'args': []
            }), "*");
          }
        }
      }
    }
  }
}

// ---------------------------------------------------------------------------------------------------------------------
// YouTube Player API
// Use API with existing <iframe>
// ---------------------------------------------------------------------------------------------------------------------
// https://developers.google.com/youtube/iframe_api_reference#Example_Video_Player_Constructors
// ---------------------------------------------------------------------------------------------------------------------
// Load the IFrame Player API code asynchronously
const tag = document.createElement('script')
tag.id = 'iframe-demo';
tag.src = 'https://www.youtube-nocookie.com/iframe_api';
const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let player

function onYouTubeIframeAPIReady() {
  for (let i = 0; i < iframeVideoWraps.length; i++) {
    if (iframeVideoWraps[i]) {
      const iframe = iframeVideoWraps[i].getElementsByTagName('iframe')[0]
      player = new YT.Player(iframe, {
        events: {
          'onStateChange': onPlayerStateChange
        }
      });
    }
  }
}

function onPlayerStateChange(event) {
  let playerStatus = event.data
  if (playerStatus === 1) { // playing
    pauseAllYoutubeVideosExcept(event.target.h);
    stopAllPlayerVideos();
  }
}




